// modules
import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setMedicalDeviceManagementList } from 'src/store/modules/actions'

// constants
import {
  DATE_TIME_FORMAT_FOR_SERVER,
  GET_MEDICAL_DEVICE_LIST_REPORT
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const fetchMedicalDeviceManagementList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_MEDICAL_DEVICE_LIST_REPORT,
          params,
          query
        }
      })

      dispatch(setMedicalDeviceManagementList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportMedicalDeviceManagement =
  (config = {}) =>
  async () => {
    await exportReport(
      config,
      `medical_device_report_${moment().format(
        DATE_TIME_FORMAT_FOR_SERVER
      )}.xls`
    )
  }
